import styles from "./InfoBubblesNormal.module.css";
import classNames from "classnames";
import { buildCompanyPaysLabel, useI18n } from "../../i18n";
import { companyPaysNothing } from "../../state";
import { InfoBubblesInnerProps } from "./InfoBubblesTypes.ts";

export const InfoBubblesNormal = (props: InfoBubblesInnerProps) => {
  const { t, locale, formatNumber } = useI18n();
  const doesCompanyPayNothing = companyPaysNothing(props.companyPays);
  const serviceLabel = buildCompanyPaysLabel(t, props.companyPays);
  const employerPaidCosts = props.companyPays?.totalCosts;

  const infoBubblesClass = classNames(styles.infoBubbles, {
    [styles.companyPaysNothing]: doesCompanyPayNothing,
  });

  return (
    <div className={infoBubblesClass}>
      <div className={styles.bubblesWrapper}>
        {/* Monthly Rate Bubble */}
        <button
          className={classNames(styles.bubbleButton, styles.bubbleMonthlyRate)}
          onClick={() => props.bubbleClickHandler("monthlyRate")}
          id="bubbleMonthlyRate"
          data-testid="bubbleMonthlyRate"
          aria-label={`${t("infoBubbles.monthlyRate.1")} ${formatNumber(props.monthlyRate!, { negativeAllowed: false })} ${locale.currencySymbol} ${t("infoBubbles.monthlyRate.2")}`}
        >
          <div className={styles.bubbleContent}>
            <div className={classNames(styles.text, styles.medium)}>{t("infoBubbles.monthlyRate.1")}</div>
            <div className={classNames(styles.text, styles.large, styles.value)}>
              {formatNumber(props.monthlyRate!, { negativeAllowed: false })} {locale.currencySymbol}
            </div>
            <div className={classNames(styles.text, styles.small)}>{t("infoBubbles.monthlyRate.2")}</div>
          </div>
        </button>

        {/* Employer Paid Costs Bubble */}
        {!doesCompanyPayNothing && (
          <button
            className={classNames(styles.bubbleButton, styles.bubbleAllServices)}
            onClick={() => props.bubbleClickHandler("employerPaidCosts")}
            id="bubbleAllServices"
            data-testid="bubbleAllServices"
            aria-label={`${t("infoBubbles.employerPaidCosts.1")} ${t("infoBubbles.employerPaidCosts.2")} ${formatNumber(employerPaidCosts!, { negativeAllowed: false })} ${locale.currencySymbol} ${serviceLabel}`}
          >
            <div className={styles.bubbleContent}>
              <div className={classNames(styles.text, styles.medium)}>
                <div>{t("infoBubbles.employerPaidCosts.1")}</div>
              </div>
              <div className={classNames(styles.text, styles.large, styles.value)}>
                {formatNumber(employerPaidCosts!, { negativeAllowed: false })} {locale.currencySymbol}
              </div>
              <div className={classNames(styles.text, styles.small)}>{serviceLabel}</div>
            </div>
          </button>
        )}

        {/* Savings Bubble */}
        <button
          className={classNames(styles.bubbleButton, styles.bubbleBikeSavings)}
          onClick={() => props.bubbleClickHandler("bikeSavings")}
          id="bubbleBikeSavings"
          data-testid="bubbleBikeSavings"
          aria-label={`${t("infoBubbles.bikeSavings.1")} ${formatNumber(props.bikeSavings!, { negativeAllowed: false })} ${locale.currencySymbol} ${t("infoBubbles.bikeSavings.2")}`}
        >
          <div className={styles.bubbleContent}>
            <div className={classNames(styles.text, styles.medium)}>{t("infoBubbles.bikeSavings.1")}</div>
            <div className={classNames(styles.text, styles.large, styles.value)}>
              {formatNumber(props.bikeSavings!, { negativeAllowed: false })} {locale.currencySymbol}
            </div>
            <div className={classNames(styles.text, styles.small)}>{t("infoBubbles.bikeSavings.2")}</div>
          </div>
        </button>
      </div>
    </div>
  );
};
